"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.withRouter = exports.useHistory = exports.app = exports.i18n = void 0;
// export * from './app';
var app = __importStar(require("./app"));
exports.app = app;
// 导出国际化模块，以及其类型
var i18n_1 = require("./app/i18n");
Object.defineProperty(exports, "i18n", { enumerable: true, get: function () { return i18n_1.i18n; } });
var history_context_1 = require("./app/history-context");
Object.defineProperty(exports, "useHistory", { enumerable: true, get: function () { return history_context_1.useHistory; } });
var app_1 = require("./app");
Object.defineProperty(exports, "withRouter", { enumerable: true, get: function () { return app_1.withRouter; } });
var react_router_dom_1 = require("react-router-dom");
Object.defineProperty(exports, "Link", { enumerable: true, get: function () { return react_router_dom_1.Link; } });
__exportStar(require("./app/types"), exports);
__exportStar(require("./strore"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9saWIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSx5QkFBeUI7QUFDekIseUNBQTZCO0FBR3BCLGtCQUFHO0FBRlosZ0JBQWdCO0FBQ2hCLG1DQUFvRTtBQUEzRCw0RkFBQSxJQUFJLE9BQUE7QUFHYix5REFBbUQ7QUFBMUMsNkdBQUEsVUFBVSxPQUFBO0FBQ25CLDZCQUFtQztBQUExQixpR0FBQSxVQUFVLE9BQUE7QUFDbkIscURBQXdDO0FBQS9CLHdHQUFBLElBQUksT0FBQTtBQUViLDhDQUE0QjtBQUM1QiwyQ0FBeUIiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBleHBvcnQgKiBmcm9tICcuL2FwcCc7XG5pbXBvcnQgKiBhcyBhcHAgZnJvbSBcIi4vYXBwXCI7XG4vLyDlr7zlh7rlm73pmYXljJbmqKHlnZfvvIzku6Xlj4rlhbbnsbvlnotcbmV4cG9ydCB7IGkxOG4sIEkxOE5Jbml0T3B0aW9ucywgSTE4TlRyYW5zbGF0aW9uIH0gZnJvbSBcIi4vYXBwL2kxOG5cIjtcbmV4cG9ydCB7IGFwcCB9O1xuXG5leHBvcnQgeyB1c2VIaXN0b3J5IH0gZnJvbSBcIi4vYXBwL2hpc3RvcnktY29udGV4dFwiO1xuZXhwb3J0IHsgd2l0aFJvdXRlciB9IGZyb20gXCIuL2FwcFwiO1xuZXhwb3J0IHsgTGluayB9IGZyb20gXCJyZWFjdC1yb3V0ZXItZG9tXCI7XG5cbmV4cG9ydCAqIGZyb20gXCIuL2FwcC90eXBlc1wiO1xuZXhwb3J0ICogZnJvbSBcIi4vc3Ryb3JlXCI7XG4iXX0=